export default __webpack_public_path__ + "static/supercat-28951b34891c81708d87ff1d60af17c9.jpeg";